import { useQuery } from '@tanstack/react-query'
import { fetchAuditLog, type AuditLogParams } from '@/lib/api/admin-audit'

export const auditKeys = {
  all: ['admin-audit'] as const,
  list: (params: AuditLogParams) => [...auditKeys.all, 'list', params] as const,
}

export function useAdminAuditLog(params: AuditLogParams = {}) {
  return useQuery({
    queryKey: auditKeys.list(params),
    queryFn: () => fetchAuditLog(params),
  })
}
